import React, { Component } from "react";
export default function FormLoader({ icon = "spinner" }) {
  return /* @__PURE__ */ React.createElement("div", { className: "form-loader" }, /* @__PURE__ */ React.createElement("i", { className: `fa fa-spin fa-${icon}` }));
}
